<template>
  <v-toolbar flat style="overflow-x: auto; overflow-y: hidden">
    <v-chip
      v-if="selectedData.length > 0"
      close
      @click:close="$emit('clearSelected')"
    >
      {{ `${selectedData.length} data(s) selected` }}
    </v-chip>
    <v-spacer />
    <v-btn
      color="primary"
      class="mb-2 rounded-pill elevation-0"
      @click="$emit('broadcast', false)"
      :style="{ 'margin-right': '10px' }"
      :disabled="loading"
    >
      {{ isEdit ? 'Edit' : 'Send' }} Message
    </v-btn>
    <v-btn
      color="error"
      class="mb-2 rounded-pill elevation-0"
      @click="$emit('broadcast', true)"
      :style="{ 'margin-right': '10px', color: 'white' }"
      :disabled="loading"
    >
      {{ isEdit ? 'Edit' : 'Send' }} Message to All
    </v-btn>
    <v-btn
      icon
      color="warning"
      class="mb-2"
      @click="$emit('refresh')"
      :style="{ 'margin-right': '10px' }"
      :loading="loading"
      :disabled="loading"
    >
      <v-icon>mdi-refresh</v-icon>
      <template v-slot:loader>
        <span class="custom-loader">
          <v-icon light>mdi-cached</v-icon>
        </span>
      </template>
    </v-btn>
  </v-toolbar>
</template>

<script>
export default {
  name: "TableTopBroadcastList",
  props: {
    selectedData: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
